module.exports = __webpack_public_path__ + "static/media/1.ecc12094.jpg";